import React, {Component, PropTypes} from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {bindActionCreators} from 'redux';
import {autobind} from 'core-decorators';
import classNames from 'classnames';
import {connect} from 'store';
import * as actions from 'store/search/actions';
import {toggleEntityMenu} from 'store/ui/actions';
import EntityMenu from '../entity-menu/entity-menu';
import Input from './input';
import Tools from './tools';
import Dropdown from './dropdown';

export class Search extends Component {
    static propTypes = {
        focus: PropTypes.bool.isRequired,
        query: PropTypes.string.isRequired,
        suggesting: PropTypes.bool.isRequired,
        suggestions: ImmutablePropTypes.list.isRequired,
        suggestionIndex: PropTypes.number.isRequired,
        results: ImmutablePropTypes.list.isRequired,
        resultIndex: PropTypes.number.isRequired,
        compact: PropTypes.bool.isRequired,
        rtl: PropTypes.bool.isRequired,
        setFocus: PropTypes.func.isRequired,
        setQuery: PropTypes.func.isRequired,
        searchPartialTranscriptToken: PropTypes.func.isRequired,
        searchActiveSuggestion: PropTypes.func.isRequired,
        clear: PropTypes.func.isRequired,
        setSuggestion: PropTypes.func.isRequired,
        prevSuggestion: PropTypes.func.isRequired,
        nextSuggestion: PropTypes.func.isRequired,
        prevResult: PropTypes.func.isRequired,
        nextResult: PropTypes.func.isRequired,
        explore: PropTypes.func.isRequired,
        language: PropTypes.string.isRequired,
    };

    @autobind
    handleKeyDown(event) {
        switch (event.keyCode) {
            case 13: // enter
                this.props.setFocus(false);
                if (this.props.suggestionIndex >= 0) {
                    this.props.searchActiveSuggestion();
                } else if (this.props.resultIndex >= 0) {
                    this.props.nextResult();
                } else {
                    this.props.searchPartialTranscriptToken(this.props.query);
                }
                break;

            case 38: // arrow up
                event.preventDefault();
                this.props.prevSuggestion();
                break;

            case 40: // arrow down
                event.preventDefault();
                this.props.nextSuggestion();
                break;

            case 27: // escape
                this.props.setFocus(false);
                break;

            default: // Do nothing, we only care about the above :)
        }
    }

    render() {
        const className = classNames('cielo24-vwrap-search-bar', {'cielo24-vwrap-compact': this.props.compact});

        return (
            <div className={className}>
                <EntityMenu />
                <div className='cielo24-vwrap-search'>
                    <Input
                        key={`search-input-${this.props.language}`}
                        query={this.props.query}
                        focus={this.props.focus}
                        setFocus={this.props.setFocus}
                        setQuery={this.props.setQuery}
                        onKeyDown={this.handleKeyDown}
                    />
                    <Tools
                        results={this.props.results}
                        resultIndex={this.props.resultIndex}
                        compact={this.props.compact}
                        rtl={this.props.rtl}
                        prevResult={this.props.prevResult}
                        nextResult={this.props.nextResult}
                        clear={this.props.clear}
                    />
                    <Dropdown
                        focus={this.props.focus}
                        query={this.props.query}
                        suggesting={this.props.suggesting}
                        suggestions={this.props.suggestions}
                        suggestionIndex={this.props.suggestionIndex}
                        onItemFocus={this.props.setSuggestion}
                        onItemClick={this.props.searchActiveSuggestion}
                        onEmptyClick={this.props.explore}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    focus: state.search.get('focus'),
    query: state.search.get('query'),
    suggesting: state.search.get('suggesting'),
    suggestions: state.search.get('suggestions'),
    suggestionIndex: state.search.get('suggestionIndex'),
    results: state.search.get('results'),
    resultIndex: state.search.get('resultIndex'),
    compact: state.ui.get('compact'),
    rtl: state.config.get('rtl'),
    language: state.config.get('language'),
});

const mapDispatchToProps = (dispatch) => ({
    ...bindActionCreators(actions, dispatch),
    explore: () => dispatch(toggleEntityMenu()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Search);



// WEBPACK FOOTER //
// ./scripts/components/search/search.js